/**
 * JWT exp 是 UTC Unix 秒数，避免将服务器无时区日期误当作浏览器本地时间。
 * 这里只读取客户端会话截止时间；签名及访问权限仍由后端验证。
 */
export function getTokenExpiration(token) {
  try {
    const parts = String(token || "").split(".");
    if (parts.length !== 3) return NaN;
    const payload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = payload.padEnd(Math.ceil(payload.length / 4) * 4, "=");
    const { exp } = JSON.parse(window.atob(padded));
    if (typeof exp !== "number" || !Number.isFinite(exp) || exp <= 0) return NaN;
    const expiresAt = exp * 1000;
    return Number.isSafeInteger(expiresAt) ? expiresAt : NaN;
  } catch {
    return NaN;
  }
}
